export default __webpack_public_path__ + "static/color-emphasis-level-inverse-light-486d2b177308037c3d9af0b35ff6b20e.png";